import Tippy from "@tippyjs/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Key } from "./keyboard_shortucts";
export const Hint = ({ text, shortcut, shortcut2 }) => {
    const { t } = useTranslation();
    return React.createElement(React.Fragment, null,
        text && React.createElement("span", { dangerouslySetInnerHTML: { __html: text } }),
        shortcut &&
            React.createElement("div", { className: "shortcut" },
                t('keyboard_shortcut'),
                ":\u00A0",
                React.createElement(Key, { k: shortcut.key, ctrl: shortcut.ctrl }),
                shortcut2 && React.createElement(React.Fragment, null,
                    " ",
                    t('or'),
                    " ",
                    React.createElement(Key, { k: shortcut2.key, ctrl: shortcut2.ctrl }))));
};
/** custom version of Tippy that hides itself if content is empty */
export const Tip = (props) => props.content ? React.createElement(Tippy, Object.assign({}, props), props.children) : React.createElement(React.Fragment, null, props.children);
/** Allows raw html to be passed. */
export const TipHtml = (props) => props.content
    ? React.createElement(Tippy, Object.assign({}, props, { content: React.createElement("span", { dangerouslySetInnerHTML: { __html: props.content } }) }), props.children)
    : React.createElement(React.Fragment, null, props.children);
export const BetaTag = ({ extraClass = "" }) => React.createElement("div", { className: "badge badge-secondary " + extraClass }, "BETA");
/** Converts \n to <br/> */
export const Nl = ({ children }) => React.createElement("span", { style: { whiteSpace: "pre-line" } }, children);
